(function(){
    'use strict'; 
    angular.module('Services').service('AccountingSurchargeTable', AccountingSurchargeTable);
    AccountingSurchargeTable.$inject = [
        'TableLiteFactory'
    ]; 

    function AccountingSurchargeTable(
        TableLiteFactory
    ){
        return function(data, updateCallback, isViewMode){
            const headers = [
                {
                    label: 'DESCRIPTION', 
                    viewName: 'description', 
                    fieldName: 'description', 
                    width: '50%' 
                }, {
                    label: 'VALUE', 
                    viewName: 'valueEdit', 
                    fieldName: 'value', 
                   
                    addOnLabel: 'AUD',
                    class: 'text-center', 
                }
            ];

            const tableData= {
                form: data.form, 
                config: {
                    tableMinHeight: '200px', 
                    noPagination: true, 
                    noHeaders: false, 
                    noItemView: true, 
                    noFooter: true
                }, 
                headers: headers,
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function(callback) {
                    callback({content: data.surchargesData})
                }, 
                callbackFormat:['success', 'error', 'filter'], 
                postRequestCallback: data => {
                    buildTableData(data); 
                },
                postRequestErrorCallback: data => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20, 
                    page: 0, 
                    sort: 'id,desc'
                }
            });

            function buildTableData(rowData){
                if(!rowData) { return tableData; }
                tableActions.initializeTableData(rowData); 
                angular.forEach(rowData.content, row => {
                    row.description = row.description.toUpperCase();
                    row.valueEdit = {
                        url       : '/templates/directives/intellectual-table/body-cells/unit-input.html',
                        value     : row.value, 
                        valueType : 'monitary',
                        id        : row.description,
                        addOnLabel: data.currency,
                        onChange  : updateCallback,
                        disabled  : isViewMode
                    }
                    tableData.data.push(row);
                });
            }

            function getTableSurchargesData(){
                return tableData.data;
            }

            function getSurchargesTotal(runningTotal){
                let total = Number(runningTotal)
                tableData.data.forEach(data => {
                    total = Number(total) + Number(data.valueEdit.value);
                });
                return total.toFixed(2);
            }

            this.getSurchargesTotal = getSurchargesTotal;
            this.getTableSurchargesData = getTableSurchargesData;
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/AccountingSurchargeTable.js